import { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { TokenInput } from '../components/TokenInput';

export function Setup() {
  const { login } = useAuth();
  const [initialToken, setInitialToken] = useState<string | undefined>(undefined);

  // Check for token in URL (from QR code scan) and pre-fill the input
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {
      // Pre-fill the token input
      setInitialToken(token);
      // Clear the token from URL for security
      window.history.replaceState({}, '', '/');
    }
  }, []);

  return (
    <div className="flex min-h-full flex-col bg-background">
      {/* Header */}
      <header className="bg-primary px-4 py-6 text-center text-primary-foreground safe-top">
        <h1 className="text-2xl font-bold">TCG Price Lookup</h1>
        <p className="mt-1 text-sm text-primary-foreground/80">Victory Road Outpost</p>
      </header>

      {/* Content */}
      <main className="flex flex-1 flex-col justify-center px-6 py-8">
        <div className="mx-auto w-full max-w-sm">
          <div className="mb-8 text-center">
            <h2 className="text-xl font-semibold text-foreground">
              Connect Your Device
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Enter the device token from VRO Business Manager to get started.
            </p>
          </div>

          <TokenInput onSubmit={login} initialToken={initialToken} />

          <div className="mt-8 rounded-2xl bg-card p-4">
            <h3 className="text-sm font-medium text-card-foreground">
              How to connect:
            </h3>
            <ol className="mt-2 list-inside list-decimal space-y-1 text-xs text-muted-foreground">
              <li>Log in to VRO Business Manager</li>
              <li>Go to Settings &rarr; Devices</li>
              <li>Click "Generate Token"</li>
              <li>Scan the QR code with your phone camera</li>
            </ol>
            <p className="mt-2 text-xs text-muted-foreground">
              Or copy the token manually and paste it above.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-4 py-4 text-center text-xs text-muted-foreground safe-bottom">
        <p>Version 1.0.0</p>
      </footer>
    </div>
  );
}
